import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';
import { volumeUnitField } from './common/sharedFields';
import { utilityCostFields } from './common/utilityCostFields';

export const waterUsageMetadata = {
  displayName: msg({
    message: 'Water withdrawal',
    context: 'Activity data schema name for water usage',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    quantity: {
      displayName: msg({
        message: 'Water withdrawal',
        context: 'The quantity of water used.',
      }),
      externalDescription: msg({
        message: 'The quantity of water drawn into organizational boundaries.',
        context: 'Water used',
      }),
    },
    unit: volumeUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
